<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import UtilsMixin from "@/mixins/utils";
import { reportService } from "@/services/authservice/report";
import PrintDetailCollectPay from "../../../components/ipos/print-detail-collect-pay";
import PrintDetailCollectPayReciept from "../../../components/ipos/print-detail-collect-pay-reciept";
import { commonService } from "@/services/common";
import Multiselect from "vue-multiselect";
import {listUserGroup} from "@/services/constant";
import {customerService} from "@/services/authservice/customer";
import {exportExcelV2} from "@/plugins/export-excel";
export default {
  page: {
    title: "Danh sách chứng từ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [UtilsMixin],
  components: {
    PrintDetailCollectPay,
    PrintDetailCollectPayReciept,
    Layout,
    PageHeader,
    TableLoading,
    TableEmpty,
    DatePicker,
    Multiselect
  },
  data() {
    return {
      listData: [],
      listRegion: [],
      title: "Danh sách chứng từ thu",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Tổng hợp thu chi",
          href: "/report/collect-pay",
        },
        {
          text: "Danh sách chứng từ",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fieldsPayment: [
        { key: "index", label: "#" },
        { key: "ra_time", label: "Ngày chứng từ" },
        { key: "ra_id", label: "Số chứng từ" },
        { key: "po_id", label: "Mã đơn" },
        { key: "customer_name", label: "Khách hàng" },
        { key: "total_amount", label: "Tổng tiền" },
        { key: "payment_amount", label: "Tiền thanh toán" },
        { key: "payment_type", label: "Phương thức thanh toán"},
        { key: "after_pay_amount", label: "Dư nợ sau thanh toán" },
      ],
      fieldsReceipt: [
        { key: "index", label: "#" },
        { key: "payment_time", label: "Ngày chứng từ" },
        { key: "payment_id", label: "Số chứng từ" },
        { key: "payer_name", label: "Khách hàng" },
        { key: "total_amount", label: "Tổng tiền thanh toán" },
        { key: "old_debt_amount_paid", label: "Tiền thanh toán nợ cũ" },
        { key: "payment_type", label: "Phương thức thanh toán"},
        { key: "detail_document_id", label: "Mã đơn" },
        { key: "detail_total_amount", label: "Tổng tiền" },
        { key: "detail_payment_amount", label: "Tiền thanh toán" },
        { key: "detail_after_pay_amount", label: "Dư nợ sau thanh toán" },
      ],
      isBusy: false,
      me: {},
      listPayment: [
        { id: "CASH", name: "Tiền mặt" },
        { id: "BANK", name: "Ngân hàng" },
      ],
      type: "shipper",
      listShipper: [],
      searchData: {
        customer: '',
        extra_type: '',
        date: [],
        payment: ''
      },
      localLandScapeOptions: {
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://ids.ipos.vn/css/print.min.css", // must be the path of your public folder
        ],
      },
      totalAmount: 0,
      totalPay: 0,
      totalAfterPay: 0,
      dataPrint: {},
      distributorInfo: {},
      dataSummary: {},
      listUserGroup: listUserGroup,
      listCustomer: []
    };
  },
  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    if (this.$route.query && this.$route.query.type === "RECEIPT") {
      this.title = "Danh sách chứng từ thu";
    }
    if (this.$route.query && this.$route.query.type === "PAYMENT") {
      this.title = "Danh sách chứng từ chi";
    }
    this.getStartEndMonth();
    this.getInitData();
  },
  computed: {
    rows() {
      return this.listData.length;
    },
  },
  mounted() {
    this.totalRows = this.listData.length;
  },
  methods: {
    onFiltered() {
      this.totalRows = this.listData.length;
      this.currentPage = 1;
    },

    async getStartEndMonth() {
      let date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.searchData.date = [firstDay, lastDay];
      const resDistributor = await commonService.getDistributorInfo({
        uid: this.me.distributor_uid,
      });
      this.distributorInfo = resDistributor.data.data;
    },

    async getInitData() {
      this.isBusy = true;
      const customerPromise = customerService.getListCustomer();
      // get list customer
      const resCustomer = await customerPromise;
      this.listCustomer = resCustomer.data.data;
      const {query} = this.$route;
      if(query.customer_id) {
        this.searchData.customer = this.listCustomer.find(item => item.id === query.customer_id)
      }
      if(query.extra_type){
        this.searchData.extra_type = this.listUserGroup.find(item => item.id === query.extra_type)
      }
      await this.getListPaid();
      this.isBusy = false;
    },

    async getListPaid() {
      let start = "";
      let end = "";
      const {date, customer, extra_type} = this.searchData
      if (
        date.length > 0 &&
        date[0] &&
        date[1]
      ) {
        start = date[0].setHours(0, 0, 0, 0);
        end = date[1].setHours(23, 59, 59, 999);
      } else {
        let date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.searchData.date = [firstDay, lastDay];
        start = firstDay.setHours(0, 0, 0, 0);
        end = lastDay.setHours(23, 59, 59, 999);
      }
      let param = {
        from_timestamp: start,
        to_timestamp: end,
        ra_type: this.$route.query.type,
        payment_type: this.searchData.payment ? this.searchData.payment.id : undefined,
        payer_uid: customer&&customer.id,
        extra_type: extra_type&&extra_type.id
      };
      if (this.$route.query.type === "PAYMENT") {
        const response = await reportService.getReportCollectPayDetailV2(param);
        if (response.data.error) {
          this.listData = {};
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: response.data.error.message,
          });
        } else {
          this.listData = response.data.data.map((e)=>{
            return {
              ...e,
              payment_type: e.payment_type === 'BANK' ? 'Ngân hàng' : 'Tiền mặt'
            }
          });
          this.totalAmount = 0;
          this.totalPay = 0;
          this.totalAfterPay = 0;
          this.listData.forEach((e) => {
            this.totalAmount = this.totalAmount + e.total_amount;
            this.totalPay = this.totalPay + e.payment_amount;
          });
          this.totalAfterPay = this.totalAmount - this.totalPay;
          this.totalPay = this.totalPay * -1;
        }
      }
      if (this.$route.query.type === "RECEIPT") {
        const response = await reportService.getReportCollectPayDetailV2(param);
        if (response.data.error) {
          this.listData = {};
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: response.data.error.message,
          });
        } else {
          // console.log("response", response.data.data);
          let listData = [];
          this.totalAmount = 0;
          this.totalPay = 0;
          this.totalAfterPay = 0;
          let summaryTotalAmount = 0;
          let summaryOldDebtAmountPaid = 0;
          let summaryDetailTotalAmount = 0;
          let summaryDetailPaymentAmount = 0;
          let summaryDetailAfterPayAmount = 0;
          response.data.data.forEach((e) => {
            this.totalAmount = this.totalAmount + e.total_amount;
            this.totalPay = this.totalAmount + e.total_amount;
            summaryTotalAmount = summaryTotalAmount + e.total_amount;
            summaryOldDebtAmountPaid =
              summaryOldDebtAmountPaid + e.old_debt_amount_paid;
            const { details } = e;
            if (details && details.length > 0) {
              details.forEach((element) => {
                listData.push({
                  ...e,
                  detail_document_id: element.document_id,
                  detail_total_amount: element.total_amount,
                  detail_payment_amount: element.payment_amount,
                  detail_after_pay_amount: element.total_amount - element.payment_amount,
                  payment_type: element.payment_type === 'BANK' ? 'Ngân hàng' : 'Tiền mặt'
                });
                summaryDetailTotalAmount =
                  summaryDetailTotalAmount + element.total_amount;
                summaryDetailPaymentAmount =
                  summaryDetailPaymentAmount + element.payment_amount;
                summaryDetailAfterPayAmount =
                  summaryDetailAfterPayAmount +
                  element.total_amount -
                  element.payment_amount;
              });
            } else {
              listData.push(e);
            }
          });
          this.dataSummary = {
            summaryTotalAmount,
            summaryOldDebtAmountPaid,
            summaryDetailTotalAmount,
            summaryDetailPaymentAmount,
            summaryDetailAfterPayAmount,
          };
          this.listData = listData;
          this.totalAfterPay = this.totalAmount - this.totalPay;
        }
      }
    },

    renderRegion(id) {
      const find = this.listRegion.filter((e) => e.id === id);
      return find[0].region_name;
    },

    async onSearch() {
      this.isBusy = true;
      await this.getListPaid();
      this.isBusy = false;
    },

    async onResetSearch() {
      this.isBusy = true;
      this.currentPage = 1;
      this.searchData = {
        date: [],
        payment: ''
      };
      await this.getListPaid();
      this.isBusy = false;
    },

    onExport(){
      let header = [];
      let nameTable = '';
      if(this.$route.query.type === 'PAYMENT'){
        header = this.fieldsPayment.slice(1);
        nameTable = 'Báo cáo chi tiết chi';
      }else if(this.$route.query.type === 'RECEIPT'){
        header = this.fieldsReceipt.slice(1)
        nameTable = 'Báo cáo chi tiết thu'
      }
      header = header.map(e=>{
        return {
          header: e.label,
          key: e.key
        }
      })
      let listData = this.listData.map(e=>{
        return {
          ...e,
          payment_time: this.formatDate(e.payment_time)
        }
      })
      exportExcelV2(header, listData, {
        nameFile: 'BAO_CAO_THU_CHI_CHI_TIET',
        nameTable: nameTable,
      })
    },

    onPrint() {
      this.dataPrint = {
        fromDate: this.searchData.date[0],
        toDate: this.searchData.date[1],
        totalAmount: this.totalAmount,
        totalPay: this.totalPay,
        totalAfterPay: this.totalAfterPay,
        details: this.listData,
        dataSummary: this.dataSummary,
      };
      setTimeout(() => {
        this.$htmlToPaper(
          "printReportInventory",
          this.localLandScapeOptions,
          async () => {}
        );
      }, 1000);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex search-container mb-3">
              <div class="form-group mt-0 mb-0 mr-2 min-w-200">
                <date-picker
                    :shortcuts="shortcuts"
                    v-model="searchData.date"
                    :first-day-of-week="1"
                    lang="en"
                    range
                    format="DD/MM/YYYY"
                    placeholder="Chọn khoảng thời gian"
                ></date-picker>
              </div>
              <div class="form-group mt-0 mb-0 mr-2 min-w-200">
                <multiselect
                    v-model="searchData.customer"
                    :options="listCustomer"
                    track-by="id"
                    label="customer_name"
                    placeholder="Chọn khách hàng"
                    noOptions="Danh sách trống"
                    :allowEmpty="true"
                    :show-labels="false"
                    :clear-on-select="true"
                >
                  <template slot="option" slot-scope="props">
                    <div>
                              <span class="option__title font-weight-bold">{{
                                  props.option.customer_name
                                }}</span>
                      <br />
                      <span v-if="props.option.customer_phone"
                      >- SĐT: {{ props.option.customer_phone }}<br
                      /></span>

                      <span v-if="props.option.customer_address"
                      >- Địa chỉ:
                                {{ props.option.customer_address }}</span
                      >
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="form-group mt-0 mb-0 mr-2 min-w-200">
                <multiselect
                    v-model="searchData.extra_type"
                    :options="listUserGroup"
                    track-by="id"
                    label="name"
                    placeholder="Chọn nguồn phát sinh thu"
                    noOptions="Danh sách trống"
                    :allowEmpty="true"
                    :show-labels="false"
                    :clear-on-select="true"
                ></multiselect>
              </div>
              <div class="form-group mt-0 mb-0 ml-2">
                <multiselect
                    class="w200"
                    id="payment"
                    v-model="searchData.payment"
                    :options="listPayment"
                    track-by="id"
                    label="name"
                    placeholder="Chọn phương thức TT"
                    noOptions="Danh sách trống"
                    :show-labels="false"
                ></multiselect>
              </div>
              <div class="ml-3">
                <button type="button" class="btn btn-primary" @click="onSearch">
                  Lọc
                </button>
                <button
                  type="button"
                  class="ml-2 btn btn-secondary"
                  @click="onResetSearch"
                >
                  <i class="bx bx-revision"></i>
                </button>
              </div>
              <button
                  @click="onExport"
                  type="button"
                  class="ml-auto btn btn-light mr-2"
              >
                <i
                    class="bx bx-download font-size-16 align-middle mr-2"
                ></i>
                Export
              </button>
              <button
                  type="button"
                  @click="onPrint"
                  class="btn btn-light"
              >
                <i class="bx bx-printer font-size-16 align-middle mr-2"></i> In
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="this.$route.query.type === 'PAYMENT'"
          class="alert alert-info"
        >
          Tổng tiền: {{ formatPrice(totalPay) }} đ
        </div>
        <div class="row">
          <!-- hiển thị cho type payment -->
          <div class="col-lg-12" v-if="this.$route.query.type === 'PAYMENT'">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Hiện
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;mục
                  </label>
                </div>
              </div>
            </div>
            <!-- Table payment-->
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                :items="listData"
                :fields="fieldsPayment"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                :busy="isBusy"
                table-class="scroll-table"
              >
                <template v-slot:table-busy>
                  <TableLoading />
                </template>
                <template v-slot:empty>
                  <TableEmpty />
                </template>
                <template v-slot:cell(index)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>
                <template v-slot:cell(ra_time)="row">
                  {{ formatDateUnix(row.item.ra_time) }}
                </template>
                <template v-slot:cell(total_amount)="row">
                  {{ formatPrice(row.item.total_amount) }}
                </template>
                <template v-slot:cell(payment_amount)="row">
                  {{ formatPrice(row.item.payment_amount) }}
                </template>
                <template v-slot:cell(after_pay_amount)="row">
                  {{
                    formatPrice(row.item.total_amount - row.item.payment_amount)
                  }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- hiển thị cho type receipt -->
          <div class="col-lg-12" v-if="this.$route.query.type === 'RECEIPT'">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Hiện
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;mục
                  </label>
                </div>
              </div>
            </div>
            <!-- Table payment-->
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                :items="listData"
                :fields="fieldsReceipt"
                :bordered="true"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                :busy="isBusy"
                table-class="scroll-table"
              >
                <template #thead-top="data">
                  <b-tr>
                    <b-th></b-th>
                    <b-th colspan="6">Chứng từ thu</b-th>
                    <b-th colspan="4">Đơn hàng</b-th>
                  </b-tr>
                  <b-tr>
                    <b-th>Tổng</b-th>
                    <b-th colspan="3"></b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.summaryTotalAmount)
                    }}</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.summaryOldDebtAmountPaid)
                    }}</b-th>
                    <b-th></b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.summaryDetailTotalAmount)
                    }}</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.summaryDetailPaymentAmount)
                    }}</b-th>
                    <b-th class="font-weight-bold">{{
                      formatPrice(dataSummary.summaryDetailAfterPayAmount)
                    }}</b-th>
                  </b-tr>
                </template>

                <template v-slot:table-busy>
                  <TableLoading />
                </template>
                <template v-slot:empty>
                  <TableEmpty />
                </template>
                <template v-slot:cell(index)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>
                <template v-slot:cell(payment_time)="row">
                  {{ formatDateUnix(row.item.payment_time) }}
                </template>
                <template v-slot:cell(old_debt_amount_paid)="row">
                  {{ formatPrice(row.item.old_debt_amount_paid) }}
                </template>
                <template v-slot:cell(total_amount)="row">
                  {{ formatPrice(row.item.total_amount) }}
                </template>
                <template v-slot:cell(detail_document_id)="row">
                  {{
                    row.item.detail_document_id
                      ? row.item.detail_document_id
                      : "--"
                  }}
                </template>
                <template v-slot:cell(detail_total_amount)="row">
                  {{
                    row.item.detail_total_amount ||
                    row.item.detail_total_amount === 0
                      ? formatPrice(row.item.detail_total_amount)
                      : "--"
                  }}
                </template>
                <template v-slot:cell(detail_payment_amount)="row">
                  {{
                    row.item.detail_payment_amount ||
                    row.item.detail_payment_amount === 0
                      ? formatPrice(row.item.detail_payment_amount)
                      : "--"
                  }}
                </template>
                <template v-slot:cell(detail_after_pay_amount)="row">
                  {{
                    row.item.detail_after_pay_amount ||
                    row.item.detail_after_pay_amount === 0
                      ? formatPrice(row.item.detail_after_pay_amount)
                      : "--"
                  }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div
      id="printReportInventory"
      class="bg-white p-3 text-dark d-none"
      v-if="!isBusy && this.$route.query.type === 'PAYMENT'"
    >
      <PrintDetailCollectPay
        :data="dataPrint"
        :distributor="distributorInfo"
        :me="me"
      />
    </div>

    <div
      id="printReportInventory"
      class="bg-white p-3 text-dark d-none"
      v-if="!isBusy && this.$route.query.type === 'RECEIPT'"
    >
      <PrintDetailCollectPayReciept
        :data="dataPrint"
        :distributor="distributorInfo"
        :me="me"
      />
    </div>
  </Layout>
</template>
